import { createContext } from 'react'

import noop from 'lib/function/noop'
import { SvgIconComponent } from 'components/Luxkit/SvgIcon'

export interface MapLayer {
  id: string
  title: string
  icon?: SvgIconComponent
  isSelected: boolean
}

export type MapLayerGroupId = 'itinerary' | 'leProducts'

export interface MapLayerGroup {
  id: MapLayerGroupId
  title: string
  selectAllLabel?: string
  selectionStatus: 'all' | 'some' | 'none'
  layers: Array<MapLayer>
}

export interface MapLayersContextValue {
  layerGroups: Array<MapLayerGroup>
  toggleLayer: (group: MapLayerGroupId, id: string) => void
  toggleGroup: (group: MapLayerGroupId) => void
}

const MapLayersContext = createContext<MapLayersContextValue>({ layerGroups: [], toggleLayer: noop, toggleGroup: noop })

export default MapLayersContext
